import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { StatisticsVulnerability } from '../../../models/statistics-vulnerability.model';
import { CSVColumnConfig } from 'src/app/models/csv-columns-config.model';
import { FileSaverService } from 'ngx-filesaver';

/**
 * Injectable
 */
@Injectable()
export class GlobalUtilService {
  /**
   * stores stats data for the dashboard
   */
  private statisticsData = new BehaviorSubject<StatisticsVulnerability | Record<any, any>>({});
  /**
   *
   * @ignore
   */
  constructor(private matSnackBar: MatSnackBar, private fileSaverService: FileSaverService) {}
  /**
   * get behaviour subject
   */
  getStatisticsData() {
    return this.statisticsData.value;
  }
  /**
   * set behaviour subject
   */
  setStatisticsData(value: StatisticsVulnerability) {
    return this.statisticsData.next(value);
  }

  /**
   *
   * sorts the passed data in a descending order
   *
   * @param data
   * @param key
   */
  sortByDates(data, key) {
    return data.sort((a, b) => new Date(b[key]).getTime() - new Date(a[key]).getTime());
  }

  /**
   * opens a popup for the user with the passed in message, action and/or error
   *
   * @param msg
   * @param action
   * @param error
   */
  openNotification(msg: string, action: string, error?: boolean) {
    this.matSnackBar.open(`${msg}`, action, { duration: 5000 });
  }

  /**
   * Converts a js object to a csv string
   *
   * @param array Array of objects to convert
   * @param csvColumnConfigs Configuration of csv columns
   * @returns a csv string
   */
  convertObjArrayToCSV<T>(array: T[], csvColumnConfigs: CSVColumnConfig[]): string {
    const csvRows = [csvColumnConfigs.map(({ label }) => label)];
    array.forEach((object) => {
      const row: string[] = [];
      csvColumnConfigs.forEach((column) => {
        const columnValue = object[column.key];
        let formattedValue = '';
        if (column.hasOwnProperty('format')) formattedValue = String(column.format(columnValue));
        else if (!columnValue && columnValue !== 0) formattedValue = '';
        else formattedValue = String(columnValue);
        // escape any characters that would break the csv string
        if (formattedValue.includes(',') || formattedValue.includes('\n') || formattedValue.includes('"')) {
          formattedValue = formattedValue.replace(/"/g, '""');
          formattedValue = `"${formattedValue}"`;
        }
        row.push(formattedValue);
      });
      csvRows.push(row);
    });

    return csvRows.map((row) => row.join(',')).join('\n');
  }

  /**
   * Begins a download for a csv string
   *
   * @param csv
   * @param filename
   */
  downloadCSV(csv: string, filename?: string): void {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    this.fileSaverService.save(blob, filename);
  }
}
